/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import * as _ from 'lodash';
import * as moment from 'moment';

import {ApiConfig} from '../api/api';
import {AdnHttpService} from './adn-http.service';
import {AdnHttpSender, createAdnHttpResourceSender} from './create-adn-http-resource';
import {AuthHttpInterceptorService} from '../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../app/common/directives/error/api-error-handler.service';



@Injectable({
  providedIn: 'root'
})
export class ReleaseNotesHelper {
  private readonly send: AdnHttpSender;

  constructor(
    AdnHttp: AdnHttpService,
    authHttpInterceptor: AuthHttpInterceptorService,
    ApiErrorHandler: ApiErrorHandlerService
  ) {
    this.send = createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler);
  }

  getFromId(id: string): Promise<any> {
    return this.send({
      method: 'GET',
      url: ApiConfig.obtain().getVersionedUri(['releasenotes', id]),
      params: _.assign({}, {format: 'json', concise: true})
    });
  }

  getFromUrlSlug(urlSlug: string): Promise<any> {
    return this.send({
      method: 'GET',
      url: ApiConfig.obtain().getVersionedUri(['releasenotes', urlSlug]),
      params: _.assign({}, {format: 'json', concise: true, isUrlSlug: true})
    });
  }

  getPublicFromUrlSlug(urlSlug: string): Promise<any> {
    return this.send({
      method: 'GET',
      url: ApiConfig.obtain().getVersionedUri(['publicreleasenotes', urlSlug]),
      params: _.assign({}, {format: 'json', concise: true})
    });
  }

  queryPublic(apps: string[] | null, since?: number): Promise<any[]> {
    return this.send({
      method: 'GET',
      url: ApiConfig.obtain().getVersionedUri(['publicreleasenotes']),
      params: _.assign({}, {
        format: 'json',
        apps: _.isArray(apps) ? apps : null,
        since: _.isFinite(since) ? moment.unix(since).toDate() : null
      })
    });
  }

  query(apps: string[] | null, includeAll?: boolean, state?: string, since?: number): Promise<any[]> {
    return this.send({
      method: 'GET',
      url: ApiConfig.obtain().getVersionedUri(['releasenotes']),
      params: _.assign({}, {
        format: 'json',
        apps: _.isArray(apps) ? apps : null,
        includeAll: !!includeAll,
        state: state ? state : 'ACTIVE',
        since: _.isFinite(since) ? moment.unix(since).toDate() : null
      })
    });
  }

  post(note: any): Promise<any> {
    return this.send({
      method: 'POST',
      url: ApiConfig.obtain().getVersionedUri(['releasenotes', note.id]),
      body: note
    });
  }
}
